angular.module('sellers', [
  'ngRoute'
  ,'ngCookies'
  ,'ngAnimate'
  ,'ngSanitize'
  ,'angular-cache'
  ,'infinite-scroll'
  ,'angular-gestures'
  ,'ngFileUpload'
  ,'mainController'
  ,'authController'
  ,'homeController'
  ,'offersController'
  ,'mailController'
  ,'taskController'
  ,'contactsController'
  ,'settingsController'
  ,'agentController'
  ,'agencyController'
  ,'propertyController'
  ,'postController'
  ,'sellersService'
  ,'feedController'
  ,'historyController'
  ,'marketController'
  ,'servicesController'
])
.config(function($routeProvider, $locationProvider) {
  $locationProvider.html5Mode(true);
  $routeProvider.when('/', 
                     { templateUrl: 'login.html'
                      , controller: 'AuthController' })
                .when('/login',     
                      { templateUrl: 'login.html'
                      , controller: 'AuthController' })
                // Home
                .when('/home',     
                      { templateUrl: 'home.html'
                      , controller: 'HomeController' })
                // Cookings
                .when('/offers', 
                      { templateUrl: 'offers.html'
                      , controller: 'OffersController' })
                // Mail
                .when('/mail', 
                      { templateUrl: 'mailbox.html'
                      , controller: 'MailController' })
                // Mail -> New
                .when('/mail/new', 
                      { templateUrl: 'newMail.html'
                      , controller: 'MailController' })
                // Mail - Message
                .when('/mail/message/:id', 
                      { templateUrl: 'message.html'
                      , controller: 'MailController' })
                // Activity
                .when('/activity', 
                      { templateUrl: 'tasks.html'
                      , controller: 'TaskController' })
                // Activity -> Event
                .when('/activity/event/:id', 
                      { templateUrl: 'task.html'
                      , controller: 'TaskController' })
                 // Listing
                .when('/property/:state/:id', 
                        { templateUrl: 'property.html'
                        , controller:  'PropertyController' })
                 //  Agency
                .when('/agency/:identifier', 
                        { templateUrl: 'agency.html'
                        , controller: 'AgencyController' })
                //  Agent
                .when('/agent/:id', 
                        { templateUrl: 'agent.html'
                        , controller: 'AgentController' })
                // Settings
                .when('/settings', 
                      { templateUrl: 'settings.html'
                      , controller: 'SettingsController' })
                .otherwise('/')
                // Settings
                .when('/posts', 
                      { templateUrl: 'post.html'
                      , controller: 'PostController' })
                .when('/feed', 
                      { templateUrl: 'feed.html'
                      , controller: 'FeedController' })
                .when('/history', 
                      { templateUrl: 'history.html'
                      , controller: 'HistoryController' 
                    })
                .when('/market', 
                      { templateUrl: 'market.html'
                      , controller: 'MarketController' 
                    })
                .when('/services', 
                      { templateUrl: 'services.html'
                      , controller: 'ServicesController' 
                    })
                .otherwise('/');
})

.constant('appInfo', {
            version: '2.0'
            ,name : 'Wiseberry Sellers'
            ,key : 'U8b334Ng'
            ,pkey: 'kSvkpR4H'
            ,production : true
            ,endpoint : 'http://mapp.wiseberryonline.com.au/w3/'
            ,today: moment().unix()
            ,updated: 'Friday, March 31 2017'
            ,pages: {
               home: { 
                  title: '',
                  helpText:  
                          '<p><b>Past Inspections:</b> The number of inspections that have been completed for your home.</p>' +
                          '<p><b>Views:</b> The total number of views your home has received on the Wiseberry website and microsite.</p>' +
                          '<p><b>Future Appts:</b> When an upcoming appointment has been scheduled for your home, this circle will turn red. Tap it to jump to your timeline.</p>' +
                          '<p><b>For Sale:</b> The number of properties surrounding your home that are currently for sale.</p>' +
                          '<p><b>Sold:</b> The number of properties surrounding your home that have recently been sold.</p>' +
                          '<p><b>Posts:</b> The total number of posts you, or your agent, has created and tagged with your home.</p>' 
               },
               timeline: { 
                  title: 'Timeline on my home',
                  helpText:  
                          '<p><b>Timeline:</b> An overview of all events that occur between the agreement start and end date of your property.</p>' +
                          '<p><b>->:</b> Opens further details of an appointment, including feedback from buyers.</p>'
               },
               offers: { 
                  title: 'Offers made on my home',
                  helpText:  
                          '<p><b>Offers:</b> A timeline of all offers that have been made on your property.</p>' +
                          '<p><b>Date:</b> The date the offer was made.</p>' +
                          '<p><b>$:</b> The dollar figure of the offer the buyer has made on your property.</p>' +
                          '<p><b>From:</b> The name of the buyer who made the offer.</p>'
               },
               mail: { 
                  title: 'My mailbox',
                  helpText:  
                          '<p><b>Mail:</b> A timeline of all emails that you have sent and received using Wiseberry Sellers.</p>' +
                          '<p><b>+ New:</b> Creates a new email to be sent to your listing agent.</p>' +
                          '<p><b>->:</b> Opens the content of a particular email.</p>'
               },
              market: { 
                  title: 'What\'s on in the market',
                  helpText:  
                          '<p><b>What\'s on in the market:</b> An overview of properties surrounding your home that are for sale or have recently been sold.</p>' +
                          '<p><b>Green dot:</b> A property has been listed for sale.</p>' +
                          '<p><b>Red dot:</b> A property has been marked as sold.</p>'
               },
              posts: { 
                  title: 'What is it like to live here?',
                  helpText:  
                          '<p><b>What is it like to live here:</b> Allows you to post content to be displayed on the microsite of your home, Wiseberry website and the Wiseberry Buyers app. </p>' +
                          '<p>Your aim is to capture the attention of buyers by providing them with a personal insight into how their life could be should they decide to purchase your property. An example of how this may be achieved is by posting an image of a beautiful sunset taken from your back porch, or a great meal you have had at a nearby restaurant.' +
                          '<p><b>+ New:</b> Creates a new post.</p>'+
                          '<p><b>Write Something:</b> Adds text to your post.</p>'+
                          '<p><b>Youtube Video ID:</b> Adds a Youtube video to your post. </p>'+
                          '<p>Note: The Youtube ID of the video is required. The Youtube ID is the combination of numbers and letters after the equal sign (=) of the URL of a video. For example, in the video “www.youtube.com/watch?v=UOT_6BNFUqo”, the Youtube ID is  “UOT_6BNFUqo”.</p>'+
                          '<p><b>Add Image:</b> Allows an image to be uploaded from your device and added to your post.</p>'+
                          '<p><b>(Pending):</b> Identifies that the post has been sent to your agent for approval before it becomes live on the website.</p>'
               },
               news: { 
                  title: 'Office News Feed',
                  helpText:  
                          '<p><b>Office News Feed:</b> A feed of activity from the office you are selling with, such as new listings and recent sales.</p>'
               },
              settings: { 
                  title: 'Settings',
                  helpText:  
                          '<p><b>Email Address:</b> Your email address.</p>'+
                          '<p><b>Mobile Phone:</b> Your contact number.</p>'+
                          '<p><b>Update:</b> Automatically updates your contact details in your agent\'s system.</p>'
               },
               services: { 
                  title: 'Services',
                  helpText: '<p><b>Services:</b> A list of services that may assist you in the selling process. Where available, tapping a service will open the company\'s website.</p>'
               }
             }
        })
.constant('assoc_offices', {data: [[123,214,243,252,253,254], [206,50]]})
.constant("Modernizr", Modernizr)
.config(function ($httpProvider) {
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
})
.config(function (hammerDefaultOptsProvider) {
    hammerDefaultOptsProvider.set({
        recognizers: [
          [Hammer.Tap,{ event: 'tap'}],
          [Hammer.Tap, {time: 250}],
          [Hammer.Tap, { event: 'doubletap', taps: 2 }, [], ['tap']],
          [Hammer.Press],
          [Hammer.Pan]
        ]
    });
})
.config(function (CacheFactoryProvider) {
    angular.extend(CacheFactoryProvider.defaults, { maxAge: 15 * 60 * 1000, storageMode: 'localStorage' });
})
.run(['$rootScope', '$location', '$cookieStore', 'localstorage', '$http',
    function ($rootScope, $location, $cookieStore, localstorage, $http) {
      
      $rootScope.location = $location;

       // Needed for the loading screen
      $rootScope.$on('$routeChangeStart', function(){
        $rootScope.loading = true;
      });

      $rootScope.$on('$routeChangeSuccess', function(){
        $rootScope.loading = false;
      });

      // keep user logged in after page refresh
      $rootScope.currentUser = localstorage.get('currentUser') || $cookieStore.get('currentUser') || {};

      $rootScope.$on('$locationChangeStart', function (event, next, current) {
          // Clear any cookies/storage and redirect to login page if not logged in
          if (($location.path() !== '/login' && !$rootScope.currentUser )|| (typeof $rootScope.currentListing === 'undefined')) {
              $location.path('/login');
          }
      });

    }
]);